import InputSwitch from './components/InputSwitch';

export default InputSwitch;
